export default __webpack_public_path__ + "static/media/googleplay-badge.6577102c.svg";